import type { FaireProductEntity } from "../../entity_types/product";

export const p_pvytd57ffk: FaireProductEntity = {
  token: "p_pvytd57ffk",
  type: "product",
  name: "Scooby Doo - Mystery Machine Toy Train",
  brandToken: "b_2e6hcxcqv5",
  brandName: "Masterpieces Puzzles",
  imageUrl:
    "https://cdn.faire.com/fastly/cc9121c24f3953fcbe078d7637d91e5e52ee39fe4d8ae77accb729394438d58c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9fdefa9e170e456be1e8338edd07591304b5369c489ae3e71e8a32edf1c261ce.jpeg",
    "https://cdn.faire.com/fastly/a3074e86648a71df2e6cd2603a51491ff401b023f77893ae207b6ff2362ad04b.jpeg",
  ],
  priceDollars: 9.23,
  description:
    "Bring the fun of Scooby Doo to your child’s playtime with this officially licensed Scooby Doo Mystery Machine wooden train engine, designed for toddlers and kids ages 3 and up. This magnetic Scooby Doo wooden train is compatible with most 1-inch wooden train tracks (track not included), making it a versatile addition to any train set or Scooby Doo playset. Crafted from durable wood, this detailed Mystery Machine toy train features vibrant colors and authentic design, perfect for fans of the classic Scooby Doo van toy. The push/pull-back operation encourages imaginative play and helps develop fine motor skills, while the portable size makes it easy to take on the go. Whether used as a Scooby Doo toddler toy, a Scooby Doo car toy, or as part of a larger Scooby Doo mystery machine van collection, this toy is sure to delight young fans and collectors alike. Ideal as a birthday or holiday gift, this Scooby Doo ride toy brings the excitement of the Mystery Machine to life and inspires creative adventures with friends and family. No batteries required, made from high-quality wood, and designed with safety in mind for hours of safe, engaging play.",
  tags: [],
  msrpDollars: 17.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:10.681Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
